import axios from 'axios';
const API_URL = process.env.REACT_APP_API;

export const getAll = async (filters: any) => {
  let queryParams: string[] = [];

  if (filters) {
    if (filters.init_date) {
      queryParams.push(`init_date=${filters.init_date}`);
    }
    if (filters.end_date) {
      queryParams.push(`end_date=${filters.end_date}`);
    }
    if (filters.search) {
      queryParams.push(`search=${encodeURIComponent(filters.search)}`);
    }
  }

  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  const response = await axios.get(`${API_URL}catalogos/portability${queryString}`);
  return response.data.doc.data;
};
export const sendPortability = async (values: any) => {
  const { id, nip, phoneFormat } = values;
  const response = await axios.post(`${API_URL}operation/portability/`, {
    nip: nip,
    numero_telefono: phoneFormat,
    activation_id: id,
  });
  return response;
};

export const confirmStatus = async (id: number, statusId: number) => {
  const response = await axios.post(
    `${API_URL}catalogos/portability/changeStatus/`,
    {
      id: id,
      statusId: statusId,
    }
  );
  return response;
};
